import Button from "src/components/button";

function HalauMereka() {
  return (
    <div className="pt-24 md:pt-[139px] overflow-hidden">
      {/* Hero Section */}
      <div className="relative flex flex-col justify-center items-center gap-6 md:gap-[32px] my-16 md:my-24 xl:my-[128px] mx-6 md:mx-16 xl:mx-[240px]">
        <div className="relative">
          <h1 className="text-lg md:text-[20px] py-4 md:py-[24px] px-8 md:px-[50px] font-semibold text-center">
            Meet our <span className="font-lora font-normal">Movement</span>
          </h1>
          <img
            className="absolute left-0 -top-[25px] md:-top-[33px] w-[1000px] lg:w-[265px] h-[100px] md:h-[140px]"
            src="/gifs/buble-elips.gif"
            alt=""
          />
        </div>
        <img
          className="w-full max-w-[600px]"
          src={"/images/halaumereka-logo.png"}
          alt="HalauMereka Logo"
        />
        <img
          className="absolute right-0 top-0 w-8 md:w-auto animate-float-enhanced-a hidden md:block"
          src="/icons/star-1.svg"
          alt=""
        />
        <img
          className="absolute left-0 bottom-0 md:top-auto w-6 md:w-auto animate-float-enhanced-b hidden lg:block"
          src="/icons/star-2.svg"
          alt=""
        />
      </div>

      {/* Quote Section */}
      <div className="py-16 md:py-[96px] bg-black text-white px-6 text-center">
        <h1 className="text-2xl md:text-[36px] font-semibold max-w-4xl mx-auto leading-snug">
          "Building a <span className="font-lora font-light">safer internet</span>{" "}
          through community-driven cybersecurity awareness."
        </h1>
      </div>

      {/* What is HalauMereka Section */}
      <div className="flex flex-col lg:flex-row px-6 md:px-16 xl:px-[248px] py-16 md:py-[96px] justify-center items-center gap-12 lg:gap-8">
        <div className="w-full lg:w-1/2 text-center lg:text-left flex flex-col gap-3 md:gap-[8px]">
          <h1 className="font-semibold text-2xl md:text-[32px]">
            What is <span className="font-lora font-normal">HalauMereka?</span>
          </h1>
          <p className="w-full lg:w-5/6 text-grey text-base md:text-[16px] mx-auto lg:mx-0">
            HalauMereka, a cybersecurity media platform, is a part of PT Harmoni Mitra Tekno. They focus on providing comprehensive cybersecurity solutions and promoting cybersecurity awareness through various initiatives.
          </p>
        </div>
        <div className="w-full lg:w-1/2 flex justify-center items-center">
          <img
            className="rounded-[8px] w-full max-w-[600px] lg:max-w-[1280px] shadow-lg"
            src="/images/halaumereka-content-a.webp"
            alt="HalauMereka Content"
          />
        </div>
      </div>

      <hr className="border-gray-200 mx-6 md:mx-16 xl:mx-[248px]" />

      {/* Inside HalauMereka Media Section */}
      <div className="flex flex-col lg:flex-row px-6 md:px-16 xl:px-[248px] py-16 md:py-[96px] justify-center items-center gap-16 lg:gap-[96px]">
        <div className="flex flex-col w-full lg:w-1/2 gap-8 md:gap-[32px]">
          <div className="flex justify-center lg:justify-start items-center">
            <div className="grid grid-cols-4 gap-2 md:gap-[8px] w-full max-w-[500px] lg:max-w-none">
              <img className="row-span-2 col-span-2 w-full h-full object-cover rounded-sm" src="/images/halaumereka-gallery-a.jpg" alt="" />
              <img className="w-full h-full object-cover rounded-sm" src="/images/halaumereka-gallery-b.jpg" alt="" />
              <img className="w-full h-full object-cover rounded-sm" src="/images/halaumereka-gallery-c.jpg" alt="" />
              <img className="w-full h-full object-cover rounded-sm" src="/images/halaumereka-gallery-d.jpg" alt="" />
              <img className="w-full h-full object-cover rounded-sm" src="/images/halaumereka-gallery-e.jpg" alt="" />
            </div>
          </div>
          <div className="text-center lg:text-left flex flex-col gap-3 md:gap-[8px]">
            <h1 className="font-semibold text-2xl md:text-[32px]">
              Inside <span className="font-lora font-normal">HalauMereka Media</span>
            </h1>
            <p className="w-full lg:w-5/6 text-grey text-base md:text-[16px] mx-auto lg:mx-0">
              More than just a media platform, HalauMereka is a cybersecurity movement. From breaking cyber news to step-by-step privacy guides, absolutely everything we publish is designed to empower your digital defense. Join us to track emerging threats, master data protection, and connect with top industry voices through our interactive live sessions.
            </p>
          </div>
        </div>
        
        {/* Responsive Phone Frames */}
        <div className="w-full lg:w-1/2 flex flex-col sm:flex-row justify-center gap-8 lg:gap-4">
          <div className="group w-full sm:w-1/2 relative flex justify-center items-center max-w-[250px] lg:max-w-[300px] mx-auto">
            {/* The gif width/height is set via percentages to scale perfectly with the frame */}
            <img className="absolute rounded-[12%] w-[84%] h-[95%] object-cover z-0" src="/gifs/halaumereka-content-a.gif" alt="" />
            <img className="w-full relative z-10 pointer-events-none" src="/images/iphone-15-frame.png" alt="" />
          </div>
          <div className="group w-full sm:w-1/2 relative flex justify-center items-center max-w-[250px] lg:max-w-[300px] mx-auto">
            <img className="absolute rounded-[12%] w-[84%] h-[95%] object-cover z-0" src="/gifs/halaumereka-content-b.gif" alt="" />
            <img className="w-full relative z-10 pointer-events-none" src="/images/iphone-15-frame.png" alt="" />
          </div>
        </div>
      </div>

      <hr className="border-gray-200 mx-6 md:mx-16 xl:mx-[248px]" />

      {/* Goes to Campus Section */}
      <div className="flex flex-col-reverse lg:flex-row px-6 md:px-16 xl:px-[248px] py-16 md:py-[96px] justify-center items-center gap-12 lg:gap-8">
        <div className="w-full lg:w-1/2 text-center lg:text-left flex flex-col gap-3 md:gap-[8px]">
          <h1 className="font-semibold text-2xl md:text-[32px]">
            Goes<span className="font-lora font-normal"> to Campus</span>
          </h1>
          <p className="w-full lg:w-5/6 text-grey text-base md:text-[16px] mx-auto lg:mx-0">
            Traditional academic curricula often struggle to keep pace with the rapidly evolving cyber threat landscape. To address this, we launched "HalauMereka Goes to Campus." This initiative empowers university students by delivering practical, industry-grade cybersecurity education. Through targeted seminars and workshops covering advanced topics like NGFW deployment and penetration testing, we raise awareness and equip students with the essential skills required to thrive in the modern cybersecurity workforce.
          </p>
        </div>
        
        {/* Responsive Macbook Frame */}
        <div className="group w-full lg:w-1/2 relative flex justify-center items-center max-w-[600px] lg:max-w-[700px] mx-auto">
            {/* Background for screen */}
            <div className="absolute w-[74%] h-[80%] top-[8%] bg-black z-0"></div>
            {/* The gif width/height is calculated to fit exactly inside the screen via percentages */}
            <img className="absolute w-[74%] h-[78%] top-[8%] object-cover z-0" src="/gifs/halaumereka-webinar.gif" alt="" />
            <img className="w-full relative z-10 pointer-events-none" src="/images/macbook-frame.png" alt="" />
        </div>
      </div>

      <hr className="border-gray-200 mx-6 md:mx-16 xl:mx-[248px]" />

      {/* Footer CTA */}
      <div className="relative py-24 md:py-[128px] px-6 flex flex-col gap-6 md:gap-[24px] justify-center items-center text-center overflow-hidden">
        <h1 className="text-2xl md:text-[32px] lg:text-[48px] font-bold md:leading-[50px]">
          Empower your <span className="font-lora font-medium italic">digital journey and stay informed</span><br className="hidden md:block"/>
          on key cybersecurity trends.
        </h1>
        <Button onClick={() => window.location.href='https://www.instagram.com/halaumereka.id/'} color={"black"}>
          See our Instagram
        </Button>
        <img className="absolute right-4 md:right-16 top-10 w-8 md:w-auto animate-float-enhanced-a opacity-50 md:opacity-100" src="/icons/star-1.svg" alt="" />
        <img className="absolute sm:hidden lg:absolute left-4 md:left-16 bottom-10 md:bottom-auto md:top-20 w-6 md:w-auto animate-float-enhanced-b opacity-50 md:opacity-100" src="/icons/star-2.svg" alt="" />
      </div>
    </div>
  );
}

export default HalauMereka;